import React from 'react'

import { AchievementName, Reward } from 'store/services/User'

import { ReactComponent as GoalsIcon } from 'resources/graphics/achievements-icons/goals.svg'
import { ReactComponent as Goals200Icon } from 'resources/graphics/achievements-icons/goals-200.svg'
import { ReactComponent as Goals300Icon } from 'resources/graphics/achievements-icons/goals-300.svg'
import { ReactComponent as Goals400Icon } from 'resources/graphics/achievements-icons/goals-400.svg'
import { ReactComponent as NewRecordIcon } from 'resources/graphics/achievements-icons/new-record.svg'
import { ReactComponent as PageMasterIcon } from 'resources/graphics/achievements-icons/page-master.svg'
import { ReactComponent as PageMasterBronzeIcon } from 'resources/graphics/achievements-icons/page-master-bronze.svg'
import { ReactComponent as PageMasterSilverIcon } from 'resources/graphics/achievements-icons/page-master-silver.svg'
import { ReactComponent as PageMasterGoldIcon } from 'resources/graphics/achievements-icons/page-master-gold.svg'
import { ReactComponent as PerfectMonthIcon } from 'resources/graphics/achievements-icons/perfect-month.svg'
import { ReactComponent as PerfectWeekIcon } from 'resources/graphics/achievements-icons/perfect-week.svg'
import { ReactComponent as PowerBuilderIcon } from 'resources/graphics/achievements-icons/power-builder.svg'
import { ReactComponent as PowerBuilderBronzeIcon } from 'resources/graphics/achievements-icons/power-builder-bronze.svg'
import { ReactComponent as PowerBuilderSilverIcon } from 'resources/graphics/achievements-icons/power-builder-silver.svg'
import { ReactComponent as PowerBuilderGoldIcon } from 'resources/graphics/achievements-icons/power-builder-gold.svg'
import { ReactComponent as SpeedMasterIcon } from 'resources/graphics/achievements-icons/speed-master.svg'
import { ReactComponent as SpeedMasterBronzeIcon } from 'resources/graphics/achievements-icons/speed-master-bronze.svg'
import { ReactComponent as SpeedMasterSilverIcon } from 'resources/graphics/achievements-icons/speed-master-silver.svg'
import { ReactComponent as SpeedMasterGoldIcon } from 'resources/graphics/achievements-icons/speed-master-gold.svg'
import { ReactComponent as VipIcon } from 'resources/graphics/achievements-icons/vip.svg'
import { ReactComponent as WordWizardIcon } from 'resources/graphics/achievements-icons/word-wizard.svg'
import { ReactComponent as WordWizardBronzeIcon } from 'resources/graphics/achievements-icons/word-wizard-bronze.svg'
import { ReactComponent as WordWizardSilverIcon } from 'resources/graphics/achievements-icons/word-wizard-silver.svg'
import { ReactComponent as WordWizardGoldIcon } from 'resources/graphics/achievements-icons/word-wizard-gold.svg'

interface IProps {
  reward: Reward
}

const medalAwarder = (
  score: number,
  normal: JSX.Element,
  bronze: JSX.Element,
  silver: JSX.Element,
  gold: JSX.Element
) => {
  if (score > 0 && score <= 50) {
    return normal
  } else if (score > 50 && score <= 100) {
    return bronze
  } else if (score > 100 && score <= 200) {
    return silver
  } else if (score > 200) {
    return gold
  } else {
    return normal
  }
}

const AchievementIcon: React.FC<IProps> = ({ reward }) => {
  if (!reward) return null
  switch (reward.name) {
    case AchievementName.GOALS:
      return <GoalsIcon aria-hidden="true" focusable="false" />
    case AchievementName.GOALS_200:
      return <Goals200Icon aria-hidden="true" focusable="false" />
    case AchievementName.GOALS_300:
      return <Goals300Icon aria-hidden="true" focusable="false" />
    case AchievementName.GOALS_400:
      return <Goals400Icon aria-hidden="true" focusable="false" />
    case AchievementName.NEW_RECORD:
      return <NewRecordIcon aria-hidden="true" focusable="false" />
    case AchievementName.PAGEMASTER:
      return medalAwarder(
        reward.score!,
        <PageMasterIcon aria-hidden="true" focusable="false" />,
        <PageMasterBronzeIcon aria-hidden="true" focusable="false" />,
        <PageMasterSilverIcon aria-hidden="true" focusable="false" />,
        <PageMasterGoldIcon aria-hidden="true" focusable="false" />
      )
    case AchievementName.WORD_WIZARD:
      return medalAwarder(
        reward.score!,
        <WordWizardIcon aria-hidden="true" focusable="false" />,
        <WordWizardBronzeIcon aria-hidden="true" focusable="false" />,
        <WordWizardSilverIcon aria-hidden="true" focusable="false" />,
        <WordWizardGoldIcon aria-hidden="true" focusable="false" />
      )
    case AchievementName.SPEEDMASTER:
      return medalAwarder(
        reward.score!,
        <SpeedMasterIcon aria-hidden="true" focusable="false" />,
        <SpeedMasterBronzeIcon aria-hidden="true" focusable="false" />,
        <SpeedMasterSilverIcon aria-hidden="true" focusable="false" />,
        <SpeedMasterGoldIcon aria-hidden="true" focusable="false" />
      )
    case AchievementName.POWER_BUILDER:
      return medalAwarder(
        reward.score!,
        <PowerBuilderIcon aria-hidden="true" focusable="false" />,
        <PowerBuilderBronzeIcon aria-hidden="true" focusable="false" />,
        <PowerBuilderSilverIcon aria-hidden="true" focusable="false" />,
        <PowerBuilderGoldIcon aria-hidden="true" focusable="false" />
      )
    case AchievementName.PERFECT_MONTH:
      return <PerfectMonthIcon aria-hidden="true" focusable="false" />
    case AchievementName.PERFECT_WEEK:
      return <PerfectWeekIcon aria-hidden="true" focusable="false" />
    case AchievementName.VIP:
      return <VipIcon aria-hidden="true" focusable="false" />
    default:
      return null
  }
}

export default AchievementIcon
